<template>
	<div class="quad__block__child learn__more">
		<h4 v-if="category" v-html="category"></h4>
		<h2 v-if="title" v-html="title"></h2>
		<p v-if="description" v-html="description"></p>
		<a v-if="link" :href="link">{{ link_label }}</a>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		category: {},
		title: {},
		description: {},
		link: {},
		link_label: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.learn__more {
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: flex-start;
	padding: 100px 0 0 100px;

	@media (max-width: 1366px) {
		padding: 50px 0;
	}

	h2 {
		color: white;
	}

	p {
		color: white;
		line-height: 1.75rem;
		font-weight: bold;
	}

	a {
		color: $signs-pink;
		text-decoration: none;
		font-weight: bold;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/LearnMore.vue